import { Expose } from "class-transformer";
import { IFilter } from "../types";
import { AdmittedFilter } from "@/constants/owner";
import i18n from "@/i18n";

export class Owner {
  public uuid!: string | null;

  public name!: string;

  @Expose({ name: "owner_key" })
  public ownerKey!: string;

  public document!: string | null;

  public email!: string | null;

  public phone!: string | null;

  @Expose({ name: "cell_phone" })
  public cellPhone!: string | null;

  public state!: string | null;

  public city!: string | null;

  public admitted!: boolean | false;
 
  @Expose({ name: "farm_count" }) 
  public farmCount: number = 0;
 
  @Expose({ name: "farm_area" }) 
  public farmArea: number = 0;

  public admit() {
    this.admitted = true;
    return this;
  }

  public unadmit() {
    this.admitted = false;
    return this;
  }
}

export function owner(
  uuid: string | null,
  name: string,
  ownerKey: string,
  document: string | null,
  email: string | null,
  phone: string | null,
  cellPhone: string | null,
  state: string | null,
  city: string | null,
  admitted: boolean = false
) {
  const o = new Owner();
  o.uuid = uuid;
  o.name = name;
  o.document = !!document ? document : null;
  o.ownerKey = ownerKey;
  o.email = !!email ? email : null;
  o.phone = phone;
  o.cellPhone = cellPhone;
  o.state = state;
  o.city = city;
  o.admitted = admitted;
  return o;
}

export class OwnerFilter implements IFilter {
  constructor(
    public name?: string,
    public ownerKey?: string,
    public email?: string,
    public city?: string,
    public state?: string,
    public onlyUserOwners?: boolean,
    public admitted: string = AdmittedFilter.ALL
  ) {}
}

export class OwnerAdmittedCount {

  @Expose({ name: "not_admitted" })
  public notAdmitted!: number;

  public admitted!: number;

  get admittedPercent() {
    if (this.admitted + this.notAdmitted === 0) {
      return '0';
    }
    return (this.admitted / (this.admitted + this.notAdmitted) * 100).toFixed(1);
  }

  get notAdmittedPercent() {
    if (this.admitted + this.notAdmitted === 0) {
      return '0';
    }
    return (this.notAdmitted / (this.admitted + this.notAdmitted) * 100).toFixed(1);
  }
}


export const everyOwner = new Owner();
everyOwner.name = i18n.t('owners.every-owner') as string;
everyOwner.uuid = null;
